<p-dialog [visible]="otherPaymentsModal()" (onHide)="closeOtherPaymentDialogHandler()" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal" [closeOnEscape]="false" aria-label="payment-options-dialog" data-testid="payment-options-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Modal Header -->
    <div class="surface-0 p-3 sticky left-0 top-0  z-1 w-full flex align-items-center justify-content-between border-bottom-1 border-300" data-testid="payment-dialog-header">
      <h2 class="mb-0 text-sm line-height-1">{{'POS.MEMBERSHIP_ADDON.PAYMENT_CC' | translate}}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup()" aria-label="close-payment-dialog" data-testid="close-payment-dialog"></div>
    </div>
    <!-- Modal Header -->

    <!-- Bottom Part -->
    <form [formGroup]="fgPayment" data-testid="payment-form">
      <div class="p-3 border-top-1 border-400" [ngClass]="false ? 'pointer-events-none opacity-50 ng-tns-c274-9':''" data-testid="payment-methods-container">
        <h5 class="text-sm flex align-items-center mb-2">
          <i class="fa fa-credit-card text-500 mr-3"></i>
          {{'POS.MEMBERSHIP_ADDON.CHOOSE_PAYMENT_METHOD' | translate}}
        </h5>
        @if (IsMinimumPaymentRequired() && getRequiredAmount() > 0) {
          <p class="pl-5 text-xs" data-testid="minimum-payment-notice">
            {{'common.errors.validations.MIN_PAYMENT_REQUIRED_HEADER' | translate : {RequiredAmt: getRequiredAmount(),Perc:minimumPaymentRequiredPerc(),TotalAmount:getTotalAmountInCurrency()} }}
          </p>
        }
        <!-- Other Payment -->
        @if (isCashRecurring()) {
          <div class="bg-blue-50 border-1 border-primary border-round mt-3" data-testid="other-payment-container">
            <div class="p-3 flex align-items-center justify-content-between cursor-pointer" (click)="otherpayment=!otherpayment; onlinePayment=false; paymentModeValidationSet()" aria-label="toggle-other-payment-options" data-testid="toggle-other-payment">
              <strong class="text-sm">{{'POS.MEMBERSHIP_ADDON.OTHER_PAYMENT' | translate}}</strong>
              @if (!otherpayment) {
                <i class="fa fa-circle-chevron-right text-500"></i>
              }
              @if (otherpayment) {
                <i class="fa fa-circle-chevron-down text-primary"></i>
              }
            </div>
            @if (otherpayment) {
              <div class="surface-0 border-1 border-300 border-round mx-3 mb-3 -mt-1 overflow-auto" data-testid="other-payment-options" style="max-height: 400px;">
                <!-- Content -->
                @if (showCreditBalance() && !showCreditBalanceForClientCredit()) {
                  <div class="surface-100 p-3 flex align-items-center justify-content-between border-bottom-1 border-300" data-testid="credit-balance-container">
                    <div class="flex align-items-center text-sm">
                      <p-checkbox checkboxIcon="fa fa-check" inputId="creditBalance" formControlName="frmCreditBalanceAmount" [binary]="true" aria-label="use-credit-balance" data-testid="use-credit-balance" />
                      <div class="ml-2">
                        <label for="creditBalance"><strong>{{'CREDIT_BALANCE.CREDIT_BALANCE' | translate}}</strong></label>
                        <div>{{'CREDIT_BALANCE.AVAILABLE_BALANCE' | translate}} <strong>{{getAvailableCreitbalance() | currencyformat }}</strong></div>
                      </div>
                    </div>
                  </div>
                }
                <!-- Content -->
                @if (isCreditCardAllowed$ | async) {
                  <div class="p-3 border-bottom-1 border-300 text-sm" data-testid="credit-card-option">
                    <div class="flex align-items-center">
                      <p-radioButton formControlName="otherPaymentMode"
                        name="otherPaymentMode"
                        value="credit"
                        inputId="creditCard"
                        aria-label="select-credit-card-payment"
                        data-testid="select-credit-card-payment" />
                      <label for="creditCard" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.CREDITCARD' | translate}}</label>
                    </div>
                    @if (otherPaymentMethod === 'credit') {
                      <div class="mt-3 mx-4" data-testid="credit-card-details">
                        <!-- <input pInputText id="cc-number" formControlName="frmCCNumber" class="w-full text-sm"
                        placeholder="{{'POS.MEMBERSHIP_ADDON.CARD_NO' | translate}}" type="tel"> -->
                        <div class="flex align-items-center">
                          <label for="creditCardLastFourDigits" class="font-medium text-700 text-xs mr-2 block uppercase">xxxx-xxxx-xxxx-</label>
                          <!-- <p-inputMask id="cc-number"  mask="9999" formControlName="frmCCNumber" [slotChar]="''" styleClass="text-sm w-6rem" type="tel"> </p-inputMask> -->
                          <app-input-number [formGroup]="fgPayment" [controlName]="frmCC_NumberFormControl"
                            [styleClass]="'text-sm w-6rem'" [conditionToFormat]="false"
                            aria-label="credit-card-last-four-digits" data-testid="credit-card-last-four-digits" />
                        </div>
                        <p-message severity="info" icon="fa fa-info-circle" aria-label="credit-card-info-message"  data-testid="credit-card-info-message">
                          {{'POS.MEMBERSHIP_ADDON.LAST_4_DIGIT' | translate}}
                        </p-message>
                        @if (this.frmCC_NumberFormControl.touched && this.frmCC_NumberFormControl.invalid) {
                          <app-error-msg class="mb-3"
                            [errors]="this.frmCC_NumberFormControl.errors"
                            [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCCARD' | translate" />
                        }
                        <input type="text" pInputText class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.NETWORK_TYPE' | translate}}" formControlName="frmCCNetworkType" aria-label="credit-card-network-type" data-testid="credit-card-network-type" />
                        @if (this.frmCC_NetworkTypeFormControl.touched && this.frmCC_NetworkTypeFormControl.invalid) {
                          <app-error-msg class="mb-3"
                            [errors]="this.frmCC_NetworkTypeFormControl.errors"
                            [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCNETWORKTYPE' | translate" />
                        }
                        <p-inputMask appNumberFormatInEnglish mask="99/9999" placeholder="mm/yyyy" formControlName="frmCCExpiryDate" styleClass="w-full text-sm mt-2" aria-label="credit-card-expiry-date" data-testid="credit-card-expiry-date" />
                        @if (this.frmCC_CardExpiryFormControl.touched && this.frmCC_CardExpiryFormControl.invalid) {
                          <app-error-msg class="mb-3"
                            [errors]="this.frmCC_CardExpiryFormControl.errors"
                            [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCEXPIRYDATE' | translate"
                             />
                        }
                        <input type="text" pInputText class="text-sm mt-2" formControlName="frmCCAuthCode" pattern="[a-zA-Z0-9]*" placeholder="{{'POS.MEMBERSHIP_ADDON.AUTH_CODE' | translate}}" aria-label="credit-card-auth-code" data-testid="credit-card-auth-code" />
                        @if (this.frmCC_AuthCodeFormControl.touched && this.frmCC_AuthCodeFormControl.invalid) {
                          <app-error-msg class="mb-3"
                            [errors]="this.frmCC_AuthCodeFormControl.errors"
                            [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCAUTHCARD' | translate" />
                        }
                        <div class="mt-2 flex align-items-center">
                          <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                            <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1"> {{currencySymbol$ | async}} </span>
                            <app-input-number [formGroup]="fgPayment" [controlName]="frmCC_AmountFormControl" [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate"
                              [styleClass]="'w-full text-sm'" [conditionToFormat]="true" [maxFractionDigits]="currencyDecimalPlaces"
                              aria-label="credit-card-amount" data-testid="credit-card-amount" />
                          </div>
                          <div class="text-sm flex align-items-center" id="balance" data-testid="credit-card-balance">
                            <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                            @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                              <strong>
                                <!-- {{(totalOneTimeCost - getfrmCC_Amount()) | currencyformat}} -->
                                {{ getRemainingAmount(totalOneTimeCost, getfrmCC_Amount()) | currencyformat }}
                              </strong>
                            }
                          </div>
                        </div>
                        @if (frmCC_AmountFormControl.errors && frmCC_AmountFormControl.errors.max) {
                          <div  class="p-error text-xs mb-0 required">
                            <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE' | translate}}</span>
                          </div>
                        }
                        @if (frmCC_AmountFormControl.errors && frmCC_AmountFormControl.errors.min) {
                          <div  class="p-error text-xs mb-0 required">
                            <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE' | translate :{PaymentAmount:frmCC_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                          </div>
                        }
                        <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="balance-payment-warning">
                          {{'POS.MEMBERSHIP_ADDON.BALANCEPAYMENT' | translate}}
                        </p-message>
                      </div>
                    }
                  </div>
                }
                @if (isDebitCardAllowed$ | async) {
                  <div class="p-3 border-bottom-1 border-300" data-testid="debit-card-option">
                    <div class="flex align-items-center">
                      <p-radioButton formControlName="otherPaymentMode" name="otherPaymentMode" inputId="debitCard"  value="debit"  aria-label="select-debit-card-payment" data-testid="select-debit-card-payment" />
                      <label for="debitCard" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.DEBITCARD' | translate}}</label>
                    </div>
                    @if (otherPaymentMethod === 'debit') {
                      <div class="mt-3 mx-4" data-testid="debit-card-details">
                        <!-- <p-inputNumber styleClass="w-full text-sm mt-2" formControlName="frmDCNumber"
                        placeholder="{{'POS.MEMBERSHIP_ADDON.CARD_NO' | translate}}" [format]="false">
                      </p-inputNumber> -->
                      <div class="flex align-items-center">
                        <label for="debitCardLastFourDigits" class="font-medium text-700 text-xs mr-2 block uppercase">xxxx-xxxx-xxxx-</label>
                        <!-- <p-inputMask id="cc-number" mask="9999" formControlName="frmDCNumber" [slotChar]="''" styleClass="text-sm w-6rem" type="tel"></p-inputMask> -->
                        <app-input-number [formGroup]="fgPayment" [controlName]="frmDC_NumberFormControl"
                          [styleClass]="'text-sm w-6rem'" [conditionToFormat]="false"
                          aria-label="debit-card-last-four-digits" data-testid="debit-card-last-four-digits" />
                      </div>
                      <p-message severity="info" icon="fa fa-info-circle" aria-label="debit-card-info-message" data-testid="debit-card-info-message">
                        {{'POS.MEMBERSHIP_ADDON.LAST_4_DIGIT' | translate}}
                      </p-message>
                      @if (this.frmDC_NumberFormControl.touched && this.frmDC_NumberFormControl.invalid) {
                        <app-error-msg class="mb-3"
                          [errors]="this.frmDC_NumberFormControl.errors"
                          [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCCARD' | translate" />
                      }
                      <input type="text" pInputText class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.NETWORK_TYPE' | translate}}" formControlName="frmDCNetworkType" aria-label="debit-card-network-type" data-testid="debit-card-network-type" />
                      @if (this.frmDC_NetworkTypeFormControl.touched && this.frmDC_NetworkTypeFormControl.invalid) {
                        <app-error-msg class="mb-3"
                          [errors]="this.frmDC_NetworkTypeFormControl.errors"
                          [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCNETWORKTYPE' | translate" />
                      }
                      <p-inputMask appNumberFormatInEnglish mask="99/9999" placeholder="mm/YYYY" formControlName="frmDCExpiryDate" styleClass="w-full text-sm mt-2" aria-label="debit-card-expiry-date" data-testid="debit-card-expiry-date" />
                      @if (this.frmDC_CardExpiryFormControl.touched && this.frmDC_CardExpiryFormControl.invalid) {
                        <app-error-msg class="mb-3"
                          [errors]="this.frmDC_CardExpiryFormControl.errors"
                          [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCEXPIRYDATE' | translate" />
                      }
                      <!-- <p-inputNumber styleClass="w-full text-sm mt-2" formControlName="frmDCAuthCode" placeholder="{{'POS.MEMBERSHIP_ADDON.AUTH_CODE' | translate}}" [format]="false"> </p-inputNumber> -->
                      <input type="text" pInputText class="text-sm mt-2" formControlName="frmDCAuthCode" pattern="[a-zA-Z0-9]*" placeholder="{{'POS.MEMBERSHIP_ADDON.AUTH_CODE' | translate}}" aria-label="debit-card-auth-code" data-testid="debit-card-auth-code" />
                      @if (this.frmDC_AuthCodeFormControl.touched && this.frmDC_AuthCodeFormControl.invalid) {
                        <app-error-msg class="mb-3"
                          [errors]="this.frmDC_AuthCodeFormControl.errors"
                          [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCAUTHCARD' | translate" />
                      }
                      <div class="mt-2 flex align-items-center">
                        <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                          <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1"> {{currencySymbol$ | async}} </span>
                          <!-- <p-inputNumber appArabicToEnglish styleClass="w-full text-sm" formControlName="frmDCAmt" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}" type="tel"> </p-inputNumber> -->
                          <app-input-number [formGroup]="fgPayment" [controlName]="frmDC_AmountFormControl" [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate"
                            [styleClass]="'w-full text-sm'" [conditionToFormat]="true" [maxFractionDigits]="currencyDecimalPlaces"
                            aria-label="debit-card-amount" data-testid="debit-card-amount" />
                        </div>
                        <div class="text-sm flex align-items-center" id="balance" data-testid="debit-card-balance">
                          <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' |translate}}</span>
                          @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                            <strong>
                              <!-- {{(totalOneTimeCost - getfrmDC_Amount()) | currencyformat}} -->
                              {{ getRemainingAmount(totalOneTimeCost, getfrmDC_Amount()) | currencyformat }}
                            </strong>
                          }
                        </div>
                      </div>
                      @if (frmDC_AmountFormControl.errors && frmDC_AmountFormControl.errors.max) {
                        <div  class="p-error text-xs mb-0 required">
                          <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE' | translate}}</span>
                        </div>
                      }
                      @if (frmDC_AmountFormControl.errors && frmDC_AmountFormControl.errors.min) {
                        <div  class="p-error text-xs mb-0 required">
                          <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE' | translate :{PaymentAmount:frmDC_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                        </div>
                      }
                      <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="balance-payment-warning">
                        {{'POS.MEMBERSHIP_ADDON.BALANCEPAYMENT' | translate}}
                      </p-message>
                    </div>
                  }
                </div>
              }
              @if (isCashAllowed$ | async) {
                <div class="p-3 border-bottom-1 border-300" data-testid="cash-payment-option">
                  <div class="flex align-items-center">
                    <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" value="cash" aria-label="select-cash-payment" data-testid="select-cash-payment" />
                    <label for="cash" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.CASH' | translate}}</label>
                  </div>
                  @if (otherPaymentMethod === 'cash') {
                    <div class="mt-3 mx-4" data-testid="cash-payment-details">
                      <div class="flex align-items-center">
                        <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                          <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">{{currencySymbol$ | async}}</span>
                          <!-- <p-inputNumber appArabicToEnglish  styleClass="w-full text-sm" formControlName="frmCashAmount"  mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}"> </p-inputNumber> -->
                          <app-input-number [formGroup]="fgPayment" [controlName]="frmCash_AmountFormControl" [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate"
                            [styleClass]="'w-full text-sm'" [conditionToFormat]="true" [maxFractionDigits]="currencyDecimalPlaces"
                            aria-label="cash-payment-amount" data-testid="cash-payment-amount" />
                        </div>
                        <div class="text-sm flex align-items-center" data-testid="cash-payment-balance">
                          <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                          @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                            <strong>
                              {{ getRemainingAmount(totalOneTimeCost, getfrmCash_Amount()) | currencyformat }}
                            </strong>
                          }
                        </div>
                      </div>
                      @if (frmCash_AmountFormControl.errors && frmCash_AmountFormControl.errors.max) {
                        <div  class="p-error text-xs mb-0 required">
                          <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE' | translate}}</span>
                        </div>
                      }
                      @if (frmCash_AmountFormControl.errors && frmCash_AmountFormControl.errors.min) {
                        <div  class="p-error text-xs mb-0 required">
                          <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE' | translate :{PaymentAmount:frmCash_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                        </div>
                      }
                      <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="balance-payment-warning">
                        {{'POS.MEMBERSHIP_ADDON.BALANCEPAYMENT' | translate}}
                      </p-message>
                    </div>
                  }
                </div>
              }
              @if (isChequeAllowed$ | async) {
                <div class="p-3 border-bottom-1 border-300" data-testid="cheque-payment-option">
                  <div class="flex align-items-center">
                    <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" value="cheque" inputId="cheque" aria-label="select-cheque-payment" data-testid="select-cheque-payment" />
                    <label for="cheque" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.CHEQUE' | translate}}</label>
                  </div>
                  @if (otherPaymentMethod === 'cheque') {
                    <div class="mt-3 mx-4" data-testid="cheque-payment-details">
                      <input pInputText formControlName="frmChequeBankName" class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.BANK_NAME' | translate}}" aria-label="cheque-bank-name" data-testid="cheque-bank-name" />
                      @if (this.frmCheque_BankNameFormControl.touched && frmCheque_BankNameFormControl.invalid) {
                        <app-error-msg class="mb-3"
                          [errors]="this.frmCheque_BankNameFormControl.errors"
                          [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CHEQUEBANKNAME' | translate" />
                      }
                      <p-datepicker [showIcon]="true" formControlName="frmChequeDate" [readonlyInput]="true" placeholder="{{'POS.MEMBERSHIP_ADDON.Cheque_Date' | translate}}" styleClass="w-full text-sm mt-2" aria-label="cheque-date" data-testid="cheque-date" />
                      @if (this.frmCheque_DateFormControl.touched && frmCheque_DateFormControl.invalid) {
                        <app-error-msg class="mb-3"
                          [errors]="this.frmCheque_DateFormControl.errors"
                          [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CHEQUEDATE' | translate" />
                      }
                      <div class="mt-2 flex align-items-center">
                        <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                          <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">
                            {{currencySymbol$ | async}}
                          </span>
                          <!-- <p-inputNumber appArabicToEnglish styleClass="w-full text-sm" inputStyleClass="px-1" formControlName="frmChequeAmount" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}">
                        </p-inputNumber> -->
                        <app-input-number [formGroup]="fgPayment" [controlName]="frmCheque_AmountFormControl" [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate"
                          [styleClass]="'w-full text-sm'" [conditionToFormat]="true" [maxFractionDigits]="currencyDecimalPlaces"
                          aria-label="cheque-amount" data-testid="cheque-amount" />
                      </div>
                      <div class="text-sm flex align-items-center" id="balance" data-testid="cheque-balance">
                        <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                        @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                          <strong>
                            {{ getRemainingAmount(totalOneTimeCost, getfrmCheque_Amount()) | currencyformat }}
                          </strong>
                        }
                      </div>
                    </div>
                    @if (frmCheque_AmountFormControl.errors && frmCheque_AmountFormControl.errors.max) {
                      <div  class="p-error text-xs mb-0 required">
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE' | translate}}</span>
                      </div>
                    }
                    @if (frmCheque_AmountFormControl.errors && frmCheque_AmountFormControl.errors.min) {
                      <div  class="p-error text-xs mb-0 required">
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE' | translate :{PaymentAmount:frmCheque_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                      </div>
                    }
                    <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="balance-payment-warning">
                      {{'POS.MEMBERSHIP_ADDON.BALANCEPAYMENT' | translate}}
                    </p-message>
                  </div>
                }
              </div>
            }
            @if (isUpiAllowed$ | async) {
              <div class="p-3 border-bottom-1 border-300" data-testid="upi-payment-option">
                <div class="flex align-items-center">
                  <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" value="upi" inputId="upi" aria-label="select-upi-payment" data-testid="select-upi-payment" />
                  <label for="upi" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.UPI' | translate}}</label>
                </div>
                @if (otherPaymentMethod === 'upi') {
                  <div class="mt-3 mx-4" data-testid="upi-payment-details">
                    <input pInputText formControlName="frmUpiProvider" class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.UPI_PROVIDER' | translate}}" aria-label="upi-provider" data-testid="upi-provider" />
                    @if (this.frmUpiProviderFormControl.touched && this.frmUpiProviderFormControl.invalid) {
                      <app-error-msg class="mb-3"
                        [errors]="this.frmUpiProviderFormControl.errors"
                        [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_UPIID' | translate" />
                    }
                    <input pInputText formControlName="frmUpiVpaid" class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.UPI_VPA_ID' | translate}}" aria-label="upi-vpa-id" data-testid="upi-vpa-id" />
                    @if (this.frmUpiVpaidFormControl.touched && this.frmUpiVpaidFormControl.invalid) {
                      <app-error-msg class="mb-3"
                        [errors]="this.frmUpiVpaidFormControl.errors"
                        [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_VPAID' | translate" />
                    }
                    <div class="mt-2 flex align-items-center">
                      <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                        <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">
                          {{currencySymbol$ | async}}
                        </span>
                        <!-- <p-inputNumber appArabicToEnglish styleClass="w-full text-sm" inputStyleClass="px-1" formControlName="frmUpiAmount" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}">
                      </p-inputNumber> -->
                      <app-input-number [formGroup]="fgPayment" [controlName]="frmUpi_AmountFormControl" [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate"
                        [styleClass]="'w-full text-sm'" [conditionToFormat]="true" [maxFractionDigits]="currencyDecimalPlaces"
                        aria-label="upi-amount" data-testid="upi-amount" />
                    </div>
                    <div class="text-sm flex align-items-center" id="balance" data-testid="upi-balance">
                      <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                      @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                        <strong>
                          {{ getRemainingAmount(totalOneTimeCost, getfrmUpi_Amount()) | currencyformat }}
                        </strong>
                      }
                    </div>
                  </div>
                  @if (frmUpiVpaidFormControl.errors && frmUpiVpaidFormControl.errors.max) {
                    <div  class="p-error text-xs mb-0 required">
                      <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE' | translate}}</span>
                    </div>
                  }
                  @if (frmUpiVpaidFormControl.errors && frmUpiVpaidFormControl.errors.min) {
                    <div  class="p-error text-xs mb-0 required">
                      <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE' | translate :{PaymentAmount:frmUpiVpaidFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                    </div>
                  }
                  <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="balance-payment-warning">
                    {{'POS.MEMBERSHIP_ADDON.BALANCEPAYMENT' | translate}}
                  </p-message>
                </div>
              }
            </div>
          }
          @for (paymentMode1 of this.paymentModes$ | async; track paymentMode1; let n = $index) {
            <div class="p-3 border-bottom-1 border-300" [attr.data-testid]="'payment-option-' + paymentMode1.id">
              <div class="flex align-items-center">
                <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" value="{{'otherPaymentMode_rb_' + paymentMode1.id}}" inputId="{{'otherPaymentMode_rb_' + paymentMode1.id}}" label="{{paymentMode1.name_primary_language}}" [attr.aria-label]="'select-payment-mode-' + paymentMode1.name_primary_language" [attr.data-testid]="'select-payment-mode-' + paymentMode1.name_primary_language" />
                <label for="{{'otherPaymentMode_rb_' + paymentMode1.id}}" class="text-sm ml-2">{{paymentMode1.name_primary_language}}</label>
              </div>
              @if (otherPaymentMethod === 'otherPaymentMode_rb_' + paymentMode1.id) {
                <div class="mt-3 mx-4" [attr.data-testid]="'payment-details-' + paymentMode1.name_primary_language">
                  @if (checkPaymentModeRequiresRefNumber(paymentMode1)) {
                    <input
                      type="text"
                      pInputText
                      class="w-full text-sm mt-2"
                      [placeholder]="'POS.MEMBERSHIP_ADDON.REFERENCE_NUMBER' | translate"
                      formControlName="{{'inp_otherPaymentMode_refno' + paymentMode1.id}}"
                      [attr.aria-label]="'payment-reference-' + paymentMode1.name_primary_language"
                      [attr.data-testid]="'payment-reference-' + paymentMode1.name_primary_language"/>
                  }
                  @if (getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id) && getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id).touched && getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id).invalid) {
                    <app-error-msg class="mb-3"
                      [errors]="getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id).errors"
                      [fieldLabel]="'POS.MEMBERSHIP_ADDON.REFERENCE_NUMBER' | translate" />
                  }
                  <div class="flex align-items-center mt-2">
                    <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                      <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">{{currencySymbol$ | async}}</span>
                      <!-- <p-inputNumber
                      appArabicToEnglish
                      styleClass="w-full text-sm"
                      formControlName="{{'inp_otherPaymentMode_' + paymentMode1.id}}"
                      mode="decimal"
                      [maxFractionDigits]="4"
                      placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}">
                    </p-inputNumber> -->
                    <app-input-number [formGroup]="fgPayment" [controlName]="getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id)"
                      [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate"
                      [styleClass]="'w-full text-sm'" [conditionToFormat]="true" [maxFractionDigits]="currencyDecimalPlaces"
                      [attr.aria-label]="'payment-amount-' + paymentMode1.name_primary_language"
                    [attr.data-testid]="'payment-amount-' + paymentMode1.name_primary_language" />
                  </div>
                  <div class="text-sm flex align-items-center" [attr.data-testid]="'payment-balance-' + paymentMode1.name_primary_language">
                    <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' |translate}}</span>
                    @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                      <strong>
                        {{ getPaymentBalance(totalOneTimeCost,paymentMode1.id) | currencyformat}}
                      </strong>
                    }
                  </div>
                </div>
                @if (getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id)
                  && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors
                  && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors.max) {
                  <div
                    class="p-error text-xs mb-0 required"
                    >
                    <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE' | translate}}</span>
                  </div>
                }
                @if (getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id)
                  && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors
                  && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors.min) {
                  <div
                    class="p-error text-xs mb-0 required"
                    >
                    <span class="p-error mt-1 validationerror">
                      {{'common.errors.validations.MIN_PAYMENT_VALUE' | translate :{PaymentAmount:getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).value, TotalAmount: getRequiredAmount()} }}
                    </span>
                  </div>
                }
                <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="balance-payment-warning">
                  {{'POS.MEMBERSHIP_ADDON.BALANCEPAYMENT' | translate}}
                </p-message>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (otherpayment) {
      <div class="p-3 sticky left-0 bottom-0 w-full z-1 surface-0 border-top-1 border-300">
        <p-button [loading]="isSubmitting" label="{{'POS.MEMBERSHIP_ADDON.CONTINUE' | translate}}" styleClass="w-full" (click)="closePaymentPopup(false)" aria-label="continue-payment" data-testid="continue-payment-button" />
      </div>
    }
  </div>
}

@if (!isCashRecurring()) {
  <div data-testid="offline-payment-not-configured">
    {{'POS.MEMBERSHIP_ADDON.OFFLINE_PAYMENT_IS_NOT_CONFIGURED' | translate}}
  </div>
}
<!-- Other Payment -->
</div>
</form>
<!-- Bottom Part -->
</ng-template>
</p-dialog>
